import { Tag } from '@volvo/vcdk-react';
import { useTranslation } from 'react-i18next';

import type { IWifiNetworkRow } from '@/service/vpc/types/IWifiConfiguration';

import { getWifiSignalIcon } from '@/utils/wifi-signal';

type Status = 'connected' | 'not_connected' | 'lost_connection';

const getStatus = (row: IWifiNetworkRow): Status => {
  if (row.isConnected) return 'connected';
  if (row.connectionDateTime) return 'lost_connection';
  return 'not_connected';
};

type Props = {
  row: IWifiNetworkRow;
};

const WifiConnectionStatus: React.FC<Props> = ({ row }) => {
  const { t } = useTranslation();

  const status = getStatus(row);

  const config: Record<Status, { label: string; variant: 'success-subtle' | 'neutral-subtle' | 'error-subtle' }> = {
    connected: {
      label: t(($) => $.components.table.network_settings_table.connected),
      variant: 'success-subtle',
    },
    not_connected: {
      label: t(($) => $.components.table.network_settings_table.not_connected),
      variant: 'neutral-subtle',
    },
    lost_connection: {
      label: t(($) => $.components.table.network_settings_table.lost_connection),
      variant: 'neutral-subtle',
    },
  };

  const { label, variant } = config[status];
  const icon = getWifiSignalIcon(row.signalStrength);

  return (
    <Tag variant={variant} startIcon={icon}>
      {label}
    </Tag>
  );
};

export default WifiConnectionStatus;
